import { useMemo } from 'react';

import { getContactByIdFromContacts } from './ContactService';
import type { Email } from './ContactTypes';
import { useEmails } from './useEmails';

interface EmailState {
    isLoading: boolean;
    hasError: boolean;
    email: Email | undefined;
}

export const useEmailById = (emailId: string | null | undefined): [EmailState, () => void] => {
    const [{ isLoading, hasError, emails }, fetchContacts] = useEmails();
    const email = useMemo(() => {
        if (!emailId) {
            return undefined;
        }

        return getContactByIdFromContacts<Email>(emailId, emails);
    }, [emailId, emails]);

    return [
        {
            isLoading,
            hasError,
            email,
        },
        fetchContacts,
    ];
};
